import { gql } from "graphql-tag";

export const CategoryFragment = gql`
  fragment CategoryFragment on Category {
    id
    name
    alias
    url
    path
    level
    isMeta
    img
    background
  }
`;
